import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import queryString from '@clearscore/helpers.query-string';

const getQueryParams = (state) => queryString.parse(resolveProp('router.location.search', state)) || {};

export default createSelector(getQueryParams, (queryParams) => queryParams);
